export default {
  login: {
    method: "post",
    url: "https://api.uat.qoala.app/api/v1/ai-tools/login",
  },
  ask_qa_chain: {
    method: "post",
    url: "https://api.uat.qoala.app/api/v1/ai-tools/ask_qa_chain",
  },
};
